import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import duration from "dayjs/plugin/duration";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "@fontsource/inter/300.css";
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";
import "@fontsource/inter/800.css";
import "./app/globals.css";

dayjs.extend(duration);
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(customParseFormat);

if (typeof document !== "undefined" && document.referrer && !sessionStorage.getItem("__initial_referrer__")) {
  sessionStorage.setItem("__initial_referrer__", document.referrer);
}

if (typeof window !== "undefined" && !sessionStorage.getItem("__utm_params__")) {
  const _utmKeys = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "reflink"];
  const _urlParams = new URLSearchParams(window.location.search);
  const _utmData: Record<string, string> = {};
  _utmKeys.forEach((key) => {
    const val = _urlParams.get(key);
    if (val) _utmData[key] = val;
  });
  if (Object.keys(_utmData).length > 0) {
    sessionStorage.setItem("__utm_params__", JSON.stringify(_utmData));
  }
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
